module.exports = __webpack_public_path__ + "cg.svg?4ad6f3e8cf63bc61fc684d1e23e86899";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/cg.svg
// module id = 1038
// module chunks = 0